<template>
  <VAvatar
    :color="color"
    class="mr-0"
    :size="size"
    data-testid="demonstrator-avatar"
  >
    <img
      v-if="photo"
      :src="photo"
      :alt="initials"
      class="avatar-img"
      data-testid="demonstrator-photo"
    >
    <span
      v-if="!photo"
      class="text-white font-weight-medium"
      :style="{ fontSize: `${props.size * 0.4}px` }"
      data-testid="demonstrator-initials"
    >{{ initials }}</span>
    <slot />
  </VAvatar>
</template>

<script lang="ts" setup>
import type { Demonstrator } from '~/types/account'
import { useAccountStore } from '~/stores/account'

interface Props {
  demonstrator: Demonstrator | null
  size?: number
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 46,
  color: 'rgb(var(--v-theme-header))'
})

const { processAction } = useAction()
const accountStore = useAccountStore()
const photo = ref()

const fetchPhoto = async () => {
  await processAction(async () => {
    if (props.demonstrator) {
      photo.value = await accountStore.fetchDemoPhoto(props.demonstrator)
    }
  })
}

watch(() => props.demonstrator, async () => {
  await fetchPhoto()
}, { immediate: true })

const initials = computed(() => {
  if (props.demonstrator && props.demonstrator.firstName && props.demonstrator.lastName) {
    return `${props.demonstrator.firstName.charAt(0)}${props.demonstrator.lastName.charAt(0)}`
  }
  return undefined
})
</script>

<style lang="scss" scoped>
.avatar-img {
    border-radius: inherit;
    display: inline-flex;
    height: inherit;
    width: inherit;
}
</style>
